export const BlockAccIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="20"
    fill="none"
    viewBox="0 0 21 20"
    {...props}>
    <path
      stroke="#D32F2F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.2"
      d="M10.75 18.333c4.6 0 8.333-3.734 8.333-8.334s-3.734-8.333-8.334-8.333a8.336 8.336 0 00-8.333 8.333c0 4.6 3.733 8.334 8.333 8.334zM16.499 4.166L4.832 15.833"></path>
  </svg>
);
